exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sc-form-input[data-v-0b54545c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.sc-form-input input[data-v-0b54545c]{padding:10px;color:#2c3e50;border:1px solid #b0bec5;outline:none}.sc-form-input label[data-v-0b54545c]{-ms-flex-item-align:start;align-self:flex-start;color:#2c3e50;margin-bottom:6px}", ""]);

// exports
